import { colors, fsDarkBlue, fsLightBlue, fsDarkBlueHoverLight } from './colors';

const oldThemeHeader = {
  background: fsDarkBlue,
  link: {
    color: colors.white,
    colorHover: colors.fsCyan,
  },
  icon: {
    color: colors.white,
  },
};

// primary button colors
const button = {
  background: colors.fsDarkBlue,
  backgroundHover: colors.fsDarkBlueHoverLight,
  backgroundSelected: colors.checkmark,
  backgroundDisabled: colors.fsDarkBlueDisabled,
  border: colors.fsDarkBlue,
  borderHover: colors.fsDarkBlueHoverLight,
  borderSelected: colors.checkmark,
  borderDisabled: colors.fsDarkBlueDisabled,
  label: colors.white,
};

// Check and radio boxes
const selectionBox = {
  color: colors.gray2,
  border: colors.gray2,
  label: colors.darkBlue2,
  background: colors.white,
  checked: { color: colors.checkmark, border: colors.checkmark },
  disabled: { label: colors.gray2 },
};

// Dropdown menues
const dropdown = {
  background: colors.white,
  backgroundHover: fsLightBlue,
  border: fsDarkBlue,
  label: colors.black,
};

// Code editor colors
const ace = {
  comment: '#607080',
};

const playControls = {
  background: '#DDDDDD',
  backgroundHover: '#AAAAAA',
  backgroundDisabled: '#EEEEEE',
  color: '#000000',
};

const tabs = {
  label: colors.gray2,
  labelActive: colors.fsDarkBlue,
  background: colors.white,
  backgroundActive: colors.white,
  border: colors.borderGray,
};

const modal = {
  background: colors.white,
  separator: colors.fsLightBlue,
  border: colors.fsLightBlue,
};

export const oldTheme = {
  primary: fsDarkBlue,
  primaryHover: fsDarkBlueHoverLight,
  primaryDisabled: colors.fsDarkBlueDisabled,
  secondary: fsLightBlue,
  header: fsDarkBlue,
  label: colors.black,
  text: colors.black,
  pageHeader: oldThemeHeader,
  pageFooter: oldThemeHeader,
  pageBackground: fsLightBlue,
  playControls,
  button,
  selectionBox,
  dropdown,
  ace,
  tabs,
  modal,
};
